import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import ReactSelectMaterialUi from 'react-select-material-ui';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import ImagePreview from '../../components/molecules/ImagePreview';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import listMenuChildTypes from '../../constants/MenuChildType';
import { languages, languageType } from '../../constants/Language';
import enabledStripeBilling from '../../constants/StripeBilling';
import usageTypes from '../../constants/UsageType';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    taxTypes: state.gochiMenus.taxTypes
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    backAction,
    registerAction,
    roles,
    groups,
    addConfirm,
    taxTypes,
    reducedTaxMenuPrefix,
    openAddProgress,
    progressOkAction,
    loading,
    resultMessage,
    isLanguage,
    setIsLanguage,
    shopName,
    previewImage,
    menuGenreName,
    menuSituationNames,
    menuUserTargetNames
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0];
    const USAGE_TYPE_VOUCHER = usageTypes[1];
    const USAGE_TYPE_COMBO = usageTypes[2];

    let { menuName, quantityFreeDes, description } = addConfirm;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = addConfirm.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData && languageData.translateType) {
        ({ menuName, quantityFreeDes, description } = languageData.params);
      } else {
        menuName = 'Google Translate で自動的に翻訳されるもの';
        quantityFreeDes = 'Google Translate で自動的に翻訳されるもの';
        description = 'Google Translate で自動的に翻訳されるもの';
      }
    }

    return (
      <div className={classes.root}>
        <Typography variant="h6">メニュー登録確認</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <Table className={classes.detailTable}>
            {(roles.isSecretariat ||
              roles.isChildShop ||
              roles.isGroup ||
              roles.isChildGroup) && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー種別
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {listMenuChildTypes.map(item => {
                      if (parseInt(addConfirm.menuChildType, 10) === item.id) {
                        return item.name;
                      }
                      return '';
                    })}
                  </TableCell>
                </TableRow>
                {parseInt(addConfirm.menuChildType, 10) === 3 && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      所蔵グループ選択
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {groups
                        .filter(group => group.isAllowCreateChildMenu === 1)
                        .map(item => {
                          if (
                            parseInt(addConfirm.groupId, 10) === item.groupId
                          ) {
                            return item.groupName;
                          }
                          return '';
                        })}
                    </TableCell>
                  </TableRow>
                )}
                {(parseInt(addConfirm.menuChildType, 10) === 4 ||
                  parseInt(addConfirm.menuChildType, 10) === 5) && (
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      所蔵グループ選択
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {groups
                        .filter(
                          group =>
                            group.isAllowCreateChildMenu === 0 &&
                            group.groupType.toUpperCase() !== 'OTHERS'
                        )
                        .map(item => {
                          if (
                            parseInt(addConfirm.groupId, 10) === item.groupId
                          ) {
                            return item.groupName;
                          }
                          return '';
                        })}
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
            {parseInt(addConfirm.menuChildType, 10) !== 3 &&
              parseInt(addConfirm.menuChildType, 10) !== 4 &&
              parseInt(addConfirm.menuChildType, 10) !== 5 && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    店舗名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {shopName}
                  </TableCell>
                </TableRow>
              )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                メニュー名
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {(() => {
                  if (addConfirm.reducedTaxType === 'REDUCED') {
                    return reducedTaxMenuPrefix;
                  }
                  return '';
                })()}
                {menuName}
              </TableCell>
            </TableRow>
            {addConfirm.menuChildType !== 3 && addConfirm.menuChildType !== 5 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>用途</TableCell>
                <TableCell className={classes.tableCellData}>
                  {(() => {
                    if (addConfirm.usageType === USAGE_TYPE_COMBO.id) {
                      return USAGE_TYPE_COMBO.name;
                    }
                    if (addConfirm.usageType === USAGE_TYPE_VOUCHER.id) {
                      return USAGE_TYPE_VOUCHER.name;
                    }
                    return USAGE_TYPE_MENU.name;
                  })()}
                </TableCell>
              </TableRow>
            )}
            {/* {addConfirm.menuChildType !== 3 && addConfirm.menuChildType !== 5 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>区分</TableCell>
                <TableCell className={classes.tableCellData}>
                  {(() => {
                    if (addConfirm.menuCombo === 0) {
                      return '普通';
                    }
                    return '回数券';
                  })()}
                </TableCell>
              </TableRow>
            )} */}
            {addConfirm.menuChildType !== 3 &&
              addConfirm.menuChildType !== 5 &&
              addConfirm.menuCombo === 0 && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用方法
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.menuLimitTotal === 1
                      ? '一円単位利用'
                      : '一枚単位利用'}
                  </TableCell>
                </TableRow>
              )}
            {addConfirm.subscription === 1 && enabledStripeBilling === true && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  購入頻度設定
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {`${addConfirm.subscriptionIntervalCount}${
                    addConfirm.subscriptionInterval === 'WEEK' ? '週間' : 'ヶ月'
                  }1回`}
                </TableCell>
              </TableRow>
            )}
            {addConfirm.menuCombo === 1 && (
              <>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    単価 × 発行枚数
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {`${addConfirm.priceCombo}円ｘ${addConfirm.quantity}枚`}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    付与無料枚数
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {addConfirm.quantityFree
                      ? `${addConfirm.quantityFree}枚`
                      : ''}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    おまけ
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {quantityFreeDes}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用制限
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {(() => {
                      if (addConfirm.numberUsePerDay === 0) {
                        return 'なし';
                      }
                      return '1日1枚';
                    })()}
                  </TableCell>
                </TableRow>
              </>
            )}
            {addConfirm.menuChildType !== 5 && (
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用期間
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {addConfirm.expiration && addConfirm.expiration !== ''
                    ? `${addConfirm.expiration}日間`
                    : addConfirm.expirationEndDate}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellItem}>価格</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.price}
                {`円`}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                税区分
                <br />
                ・寄付
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {taxTypes.map(item => {
                  if (
                    addConfirm.taxType &&
                    addConfirm.taxType.toString() === item.id.toString()
                  ) {
                    return item.name;
                  }
                  return '';
                })}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                軽減税率対象
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.reducedTaxCheck}
                {(() => {
                  if (addConfirm.reducedTaxType === 'REDUCED') {
                    return '対象';
                  }
                  return '対象外';
                })()}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>ジャンル</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuGenreName}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>金額表示</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.showPrice === 1 ? '表示' : '非表示'}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>
                シチュエーション
              </TableCell>
              <TableCell className={classes.tableCellData}>
                {menuSituationNames}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>贈り相手</TableCell>
              <TableCell className={classes.tableCellData}>
                {menuUserTargetNames}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>説明</TableCell>
              <TableCell className={classes.tableCellData}>
                {description}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>タグ</TableCell>
              <TableCell className={classes.tableCellData}>
                {addConfirm.tagStr}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellItem}>画像</TableCell>
              <TableCell className={classes.tableCellData}>
                <ImagePreview previewImage={previewImage} />
              </TableCell>
            </TableRow>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={registerAction} />
        </div>
        <ProgressDialog
          openProgress={openAddProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
